import graphql from '../graphql';

const query = /* GraphQL */ `
  query findOneCourse($id: ID!) {
    findOneCourse(id: $id) {
      id
      name
      description
      Priority {
        id
        name
      }
      CourseCategory {
        id
        name
      }
      User {
        id
        fullName
        photo
        roleId
      }
      expirationDate
      expirationTime
      statusChangedAt
      statusChangedBy
      coverImage
      updatedAt
      isDraft
      userCreatedId
    }
  }
`;

/**
 * @typedef {Object} Priority
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {Object} CourseCategory
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {Object} User
 * @property {string} id
 * @property {string} fullName
 * @property {string} photo
 * @property {string} roleId
 */

/**
 * @typedef {Object} CourseData
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {Priority} Priority
 * @property {CourseCategory} CourseCategory
 * @property {User} User
 * @property {string} coverImage
 * @property {string} updatedAt
 * @property {boolean} isDraft
 * @property {string} userCreatedId
 */

/**
 * Busca un curso por medio de un id
 * @param {string} id El id del curso a buscar
 * @returns {Promise<CourseData>} Información del curso
 */
const findOneCourse = async id => graphql(query, { id }).then(data => data);

export default findOneCourse;
